import { FormGroup, FormBuilder } from "@angular/forms";

export class M_SRMASTER {
    hQ_CD: string = '';
    stR_CD: string = '';
    stR_NM: string = '';
    inserT_DT: string = '';
    inserT_USER: string = '';
    updatE_DT: string = '';
    updatE_USER: string = '';
    usE_YN: string = 'Y';
    remark: string = '';

    l_CLASS_CD: string = 'new';
    l_CLASS_NM: string = '';
    s_CLASS_CD: string = 'new';
    s_CLASS_NM: string = '';
    servicE_CD: string = 'new';
    servicE_NM: string = '';
    sort: number = 1;
    price: number = 0;
    time: number = 0;
    sR_TP : string = '';
    serviceType : number = 1;
    checked : boolean = false;

    constructor(init?: Partial<M_SRMASTER>) {
        Object.assign(this, init);
    }

    toJSON(): any {
        const obj: any = {};

        Object.keys(this).forEach(key => {
            const value = (this as any)[key];
            if (
                (key === 'hR_DT' || key === 'retirE_DT') &&
                value
            ) {
                obj[key] = this.formatDate(value);
            } else {
                obj[key] = value ?? null;
            }
        });

        return obj;
    }

    fromJSON(json: any): M_SRMASTER {
        return new M_SRMASTER(json);
    }

    getAll(res: any[]): M_SRMASTER[] {
        return (res ?? []).map(e => {
            // if (e?.hR_DT) {
            //     e.hR_DT = this.parseYYYYMMDD(e.hR_DT);
            // }
            return new M_SRMASTER(e);
        });
    }

    createForm(fb: FormBuilder): FormGroup {
        return fb.group(
            {
            })
    }

    formatDate(dateString: string): string {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0')

        return `${year}${month}${day}`;
    }

    parseYYYYMMDD(value: string | number): Date | null {
        if (!value) return null;

        const str = value.toString();
        if (str.length !== 8) return null;

        const year = Number(str.substring(0, 4));
        const month = Number(str.substring(4, 6)) - 1;
        const day = Number(str.substring(6, 8));

        return new Date(year, month, day);
    }
}
